import types from "../types";
import state from "../defaultState";
import { fromJS } from "immutable";

const initialState = state.inquiry;
export default function app(state = initialState, action) {
  switch (action.type) {
    case types.GET_INQUIRY_SUCCESS:
      return state.setIn(["data"], fromJS(action.payload));
    case types.GET_MAIN_TOPIC_SUCCESS:
      return state.setIn(["mainTopic"], fromJS(action.payload));
    // case types.GET_BANNED_MESSAGES_ERROR:
    //   return state.setIn(
    //     ["error"],
    //     fromJS(
    //       action.payload.response
    //         ? action.payload.response.error
    //         : action.payload.message
    //     )
    //   );
    default:
      return state;
  }
}
